import styles from './skeleton.module.scss'

export function SkeletonSnapshot() {
  return (
    <div className={styles.page} aria-hidden>
      <div className={styles.summary} />
      <div className={styles.grid}>
        {[0, 1, 2].map(col => (
          <div key={col} className={styles.column}>
            <div className={styles.head} />
            {[0, 1, 2].map(row => (
              <div key={row} className={styles.row}>
                <div className={styles.shape} />
                <div className={styles.name} />
                <div className={styles.bar} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
